import { render, staticRenderFns } from "./xgplayer.vue?vue&type=template&id=effef1fe&scoped=true"
import script from "./xgplayer.vue?vue&type=script&lang=js"
export * from "./xgplayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effef1fe",
  null
  
)

export default component.exports